"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlaceholderView;
var React = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _Button = _interopRequireDefault(require("../../Button"));
var _StyledPlaceholderView = require("../styled/StyledPlaceholderView");
var _ykbStyledComponents = require("../../ykb-styled-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function PlaceholderView(_ref) {
  var onClick = _ref.onClick,
    text = _ref.text,
    linkText = _ref.linkText,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'round-plus' : _ref$icon,
    children = _ref.children;
  function clickHandler(e) {
    if (e) e.preventDefault();
    if (onClick) {
      onClick(e);
    }
  }
  return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/React.createElement(_StyledPlaceholderView.StyledPlaceholderView, {
      theme: theme
    }, /*#__PURE__*/React.createElement(_Icon.default, {
      name: icon,
      colorType: "primary",
      size: 72,
      onClick: clickHandler
    }), /*#__PURE__*/React.createElement(_StyledPlaceholderView.StyledPlaceholderText, null, text && text.length > 0 ? text : '', ' ', linkText && /*#__PURE__*/React.createElement(_Button.default, {
      link: "#",
      onClick: clickHandler
    }, linkText), children));
  });
}